import useLocales from "../hooks/useLocales";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import en from "date-fns/locale/en-GB";
import pl from "date-fns/locale/pl";

export default function ThemeLocalization({ children }: any) {
    const { currentLang } = useLocales();

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={currentLang.value === "en" ? en : pl}
        >
            {children}
        </LocalizationProvider>
    );
}
